import store from '@/store'

export default
{
    beforeRouteEnter(nextRoute, lastRoute, next)
    {
        const $store = this && this.$store ? this.$store : store.global

        const lastPageID = $store.routes
            .findIndex(route => route.name === lastRoute.name)
        const nextPageID = $store.routes
            .findIndex(route => route.name === nextRoute.name)

        $store.isDescending = nextPageID > lastPageID

        next()
    }
}
